import applicationRepository from './zh-TW/applicationRepository';
import component from './zh-TW/component';
import deploymentOperations from './zh-TW/deploymentOperations';
import eventEngine from './zh-TW/eventEngine';
import globalHeader from './zh-TW/globalHeader';
import menu from './zh-TW/menu';
import pages from './zh-TW/pages';
import projectSettings from './zh-TW/projectSettings';
import pwa from './zh-TW/pwa';
import settingDrawer from './zh-TW/settingDrawer';
import settings from './zh-TW/settings';
import system from './zh-TW/system';
import workbench from './zh-TW/workbench';

export default {
  'navBar.lang': '語言',
  'layout.user.link.help': '幫助',
  'layout.user.link.privacy': '隱私',
  'layout.user.link.terms': '條款',
  'app.banner.title': '智能軟體專案管理',
  'app.banner.subtitle': '軟體全生命週期智能管理系統',
  'app.footer.copyright': '2026 珊瑚智成（北京）科技有限公司',
  'app.preview.down.block': '下載此頁面到本地項目',
  ...pages,
  ...applicationRepository,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...projectSettings,
  ...component,
  ...deploymentOperations,
  ...eventEngine,
  ...workbench,
  ...system,
};
